"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var eligibility_1 = require("@bhtp-client-api/eligibility");
var airline_typeahead_service_1 = require("./airline-typeahead-service");
var car_rental_typeahead_service_1 = require("./car-rental-typeahead-service");
var country_typeahead_service_1 = require("./country-typeahead-service");
var cruise_typeahead_service_1 = require("./cruise-typeahead-service");
var hotel_typeahead_service_1 = require("./hotel-typeahead-service");
var rental_company_typeahead_service_1 = require("./rental-company-typeahead-service");
var tour_typeahead_service_1 = require("./tour-typeahead-service");
var state_typeahead_service_1 = require("./state-typeahead-service");
function bhtpAirlineTypeaheadServiceFactory(http) {
    return new airline_typeahead_service_1.BhtpAirlineTypeaheadService(http);
}
exports.bhtpAirlineTypeaheadServiceFactory = bhtpAirlineTypeaheadServiceFactory;
function bhtpCarRentalTypeaheadServiceFactory(http) {
    return new car_rental_typeahead_service_1.BhtpCarRentalTypeaheadService(http);
}
exports.bhtpCarRentalTypeaheadServiceFactory = bhtpCarRentalTypeaheadServiceFactory;
function bhtpCountryTypeaheadServiceFactory(http) {
    return new country_typeahead_service_1.BhtpCountryTypeaheadService(http);
}
exports.bhtpCountryTypeaheadServiceFactory = bhtpCountryTypeaheadServiceFactory;
function bhtpCruiseTypeaheadServiceFactory(http) {
    return new cruise_typeahead_service_1.BhtpCruiseTypeaheadService(http);
}
exports.bhtpCruiseTypeaheadServiceFactory = bhtpCruiseTypeaheadServiceFactory;
function bhtpHotelTypeaheadServiceFactory(http) {
    return new hotel_typeahead_service_1.BhtpHotelTypeaheadService(http);
}
exports.bhtpHotelTypeaheadServiceFactory = bhtpHotelTypeaheadServiceFactory;
function bhtpRentalCompanyTypeaheadServiceFactory(http) {
    return new rental_company_typeahead_service_1.BhtpRentalCompanyTypeaheadService(http);
}
exports.bhtpRentalCompanyTypeaheadServiceFactory = bhtpRentalCompanyTypeaheadServiceFactory;
function bhtpTourTypeaheadServiceFactory(http) {
    return new tour_typeahead_service_1.BhtpTourTypeaheadService(http);
}
exports.bhtpTourTypeaheadServiceFactory = bhtpTourTypeaheadServiceFactory;
function bhtpStateTypeaheadServiceFactory(stateService) {
    return new state_typeahead_service_1.BhtpStateTypeaheadService(stateService);
}
exports.bhtpStateTypeaheadServiceFactory = bhtpStateTypeaheadServiceFactory;
var BhtpTypeaheadServiceModule = (function () {
    function BhtpTypeaheadServiceModule() {
    }
    return BhtpTypeaheadServiceModule;
}());
BhtpTypeaheadServiceModule = __decorate([
    core_1.NgModule({
        providers: [
            { provide: airline_typeahead_service_1.BhtpAirlineTypeaheadService, useFactory: bhtpAirlineTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: car_rental_typeahead_service_1.BhtpCarRentalTypeaheadService, useFactory: bhtpCarRentalTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: country_typeahead_service_1.BhtpCountryTypeaheadService, useFactory: bhtpCountryTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: cruise_typeahead_service_1.BhtpCruiseTypeaheadService, useFactory: bhtpCruiseTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: hotel_typeahead_service_1.BhtpHotelTypeaheadService, useFactory: bhtpHotelTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: rental_company_typeahead_service_1.BhtpRentalCompanyTypeaheadService, useFactory: bhtpRentalCompanyTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: tour_typeahead_service_1.BhtpTourTypeaheadService, useFactory: bhtpTourTypeaheadServiceFactory, deps: [http_1.Http] },
            { provide: state_typeahead_service_1.BhtpStateTypeaheadService, useFactory: bhtpStateTypeaheadServiceFactory, deps: [eligibility_1.BhtpStateService] },
        ],
    })
], BhtpTypeaheadServiceModule);
exports.BhtpTypeaheadServiceModule = BhtpTypeaheadServiceModule;
//# sourceMappingURL=D:/a/1/s/typeahead/src/typeahead-module.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/typeahead-module.js